import APIConstant from 'constants/ApiConstant';
import { makeAutoObservable, runInAction } from 'mobx';
import { deleteRequest, getRequest, postRequest } from 'utils/apiUtils';
import { getValidDataFromResponse } from 'utils/utilities';

class ManualStore {
    isSubmittingManual = false;
    isSubmittingManualType = false;
    isFetchingManual = false;
    isFetchinfManualTypes = false;
    isDeletingManual = false;
    isDeletingManualType = false;
    rowId = '';
    manualData = [];
    manualTypes = [];

    constructor() {
        makeAutoObservable(this);
    }

    submitNewManual = body => {
        return new Promise(async (resolve, reject) => {
            try {
                const { response } = await postRequest({ url: APIConstant.INSERT_MANUAL, payload: body });
                const { result, error } = getValidDataFromResponse({ response });

                if (!error) {
                    resolve();
                } else {
                    throw new Error(`Something went wrong`);
                }
            } catch (error) {
                reject(error.message);
            }
        });
    };

    submitNewManualType = body => {
        return new Promise(async (resolve, reject) => {
            try {
                const { response } = await postRequest({ url: APIConstant.INSERT_MANUAL_TYPE, payload: body });
                const { result, error } = getValidDataFromResponse({ response });

                if (!error) {
                    resolve();
                } else {
                    throw new Error(`Something went wrong`);
                }
            } catch (error) {
                reject(error.message);
            }
        });
    };

    getManuals = (id) => {
        return new Promise(async (resolve, reject) => {
            try {
                const { response } = await getRequest({ url: id ? `${APIConstant.GET_MANUAL_LIST}?equipment_manual_type_id=${id}` : APIConstant.GET_MANUAL_LIST });
                if (response.result?.length > 0) {
                    const { result, error } = getValidDataFromResponse({ response, isRequired: false });

                    if (!error) {
                        resolve();
                        this.setManualList(result);
                    } else {
                        throw new Error(`Something went wrong`);
                    }
                } else {
                    resolve();
                    this.setManualList();
                }
            } catch (error) {
                this.setManualList();
                reject(error.message);
            }
        });
    };

    getManualsType = () => {
        return new Promise(async (resolve, reject) => {
            try {
                const { response } = await getRequest({ url: APIConstant.GET_MANUAL_TYPES });
                if (response.result?.length > 0) {
                    const { result, error } = getValidDataFromResponse({ response, isRequired: false });

                    if (!error) {
                        resolve();
                        this.setManualTypes(result);
                    } else {
                        throw new Error(`Something went wrong`);
                    }
                } else {
                    resolve();
                    this.setManualTypes();
                }
            } catch (error) {
                this.setManualTypes();
                reject(error.message);
            }
        });
    };

    deleteManual = (manualId, row) => {
        return new Promise(async (resolve, reject) => {
            try {
                const { response } = await deleteRequest({ url: `${APIConstant.DELETE_MANUAL}/${manualId}` });
                const { result, error } = getValidDataFromResponse({ response });

                if (!error) {
                    resolve();
                } else {
                    throw new Error(`Something went wrong`);
                }
            } catch (error) {
                reject();
            }
        });
    };

    deleteManualType = (manualTypeId, row) => {
        return new Promise(async (resolve, reject) => {
            try {
                const { response } = await deleteRequest({ url: `${APIConstant.DELETE_MANUAL_TYPE}/${manualTypeId}` });
                const { result, error } = getValidDataFromResponse({ response });

                if (!error) {
                    resolve();
                } else {
                    throw new Error(`Something went wrong`);
                }
            } catch (error) {
                reject();
            }
        });
    };

    setIsSubmittingManual = (value = false) => {
        runInAction(() => {
            this.isSubmittingManual = value;
        });
    };

    setIsSubmittingManualType = (value = false) => {
        runInAction(() => {
            this.isSubmittingManualType = value;
        });
    };

    setIsDeletingManual = (value = false, rowId = '') => {
        return new Promise((resolve, reject) => {
            runInAction(() => {
                this.isDeletingManual = value;
                this.rowId = rowId;
            });
            resolve();
        });
    };

    setIsDeletingManualType = (value = false, rowId = '') => {
        return new Promise((resolve, reject) => {
            runInAction(() => {
                this.isDeletingManualType = value;
                this.rowId = rowId;
            });
            resolve();
        });
    };

    setManualList = (data = []) => {
        runInAction(() => {
            this.manualData = data;
        });
    };

    setManualTypes = (data = []) => {
        runInAction(() => {
            this.manualTypes = data;
        });
    };

    setIsFetchingManual = (value = false) => {
        runInAction(() => {
            this.isFetchingManual = value;
        });
    };

    setIsFetchingManualTypes = (value = false) => {
        runInAction(() => {
            this.isFetchinfManualTypes = value;
        });
    };

}

export default ManualStore;
